import { Suspense } from 'react';
import { DataGridViewType } from '@/features/DataGrid';
import { useAppSelector } from '@/shared/model';
import { Loader } from '@/shared/ui';
import { selectMetaConfig } from '../../model/slice';
import type { DataConfig } from '../../model/types';
import { DataTable } from '../DataTable/DataTable';
import { TreeDataGrid } from '../TreeDataGrid/TreeDataGrid';

interface Props {
  isReadonly?: boolean;
  config: DataConfig;
  onReorderDimensions: (info: {
    id: string;
    oldIndex: number;
    newIndex: number;
  }) => void;
  onColumnsWidthChange: (columnName: string, newWidth?: number) => void;
}

export function DataGrid({
  isReadonly,
  config,
  onReorderDimensions,
  onColumnsWidthChange,
}: Readonly<Props>) {
  const columnsConfig = useAppSelector(selectMetaConfig);
  const {
    dataGridViewType,
    columnsWidth,
    rowHeight,
    dimensions,
    metric,
    highlight,
  } = config;

  return (
    <Suspense fallback={<Loader active />}>
      {dataGridViewType === DataGridViewType.treeDataGrid ? (
        <TreeDataGrid
          isReadonly={isReadonly}
          columnsWidth={columnsWidth}
          columnsConfig={columnsConfig}
          rowHeight={rowHeight}
          dimensions={dimensions}
          metric={metric}
          highlight={highlight}
          updateColumnsWidth={onColumnsWidthChange}
        />
      ) : (
        <DataTable
          isReadonly={isReadonly}
          columnsWidth={columnsWidth}
          columnsConfig={columnsConfig}
          rowHeight={rowHeight}
          dimensions={dimensions}
          metric={metric}
          highlight={highlight}
          reorderDimensions={onReorderDimensions}
          updateColumnsWidth={onColumnsWidthChange}
        />
      )}
    </Suspense>
  );
}
